<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
#app{
  font-family: diy-font, -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text-primary, #1D2129);
}
html, body{
  margin: 0;
  font-family: diy-font, 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  background: var(--color-bg-app, #F2F4F7);
}
.el-table .cell {
  text-align: center !important;
}
.el-table th > .cell {
  text-align: center !important;
  justify-content: center;
}
.el-table td .cell {
  text-align: center !important;
}
</style>